import { Suspense } from "react";
import { Routes, Route } from "react-router";
import { routes } from "./routes";
import { MainLayout } from "./components/layout";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ScrollToTop } from "./components/ScrollToTop";

function SuspenseLayout() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[50vh] items-center justify-center">
          <p className="text-text-muted">Loading...</p>
        </div>
      }
    >
      <ErrorBoundary>
        <Routes>
          {routes.map(({ path, component: Component }) =>
            path === "/" ? (
              <Route key={path} index element={<Component />} />
            ) : (
              <Route key={path} path={path} element={<Component />} />
            ),
          )}
        </Routes>
      </ErrorBoundary>
    </Suspense>
  );
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="*" element={<SuspenseLayout />} />
        </Route>
      </Routes>
    </>
  );
}
